import { Component, OnInit } from '@angular/core';
import { PatientLoginService } from './patientLogin.service';
import { Router, ActivatedRoute } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { Globals } from '../../../globals';
import { PatientAuthenticationService } from '../services/patientAuthentication.service';
import { AuthenticationService } from '../services/authentication.service';
import { AuthenticationResponseModel } from '../model/authentication-response.model';

@Component({
  selector: 'app-patient-login',
  templateUrl: './patientLogin.component.html',
  styleUrls: ['./patientLogin.component.css']
})
export class PatientLoginComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<PatientLoginComponent>,
    private loginService: PatientLoginService,
    private authService: AuthenticationService,
    private route: ActivatedRoute,
    private router: Router,
    public globals: Globals,
  ) { }

  username: string;
  password: string;
  token:string;
  validated: boolean = false;
  isLoading: boolean = false;
  error = '';
  returnUrl: string;
  returnParams: any = false;
  tdodialog: boolean = false;

  ngOnInit() {

    if (this.route.queryParams) {
      this.route.queryParams.subscribe(params  => {
        this.token = params['t'];
        this.username = params['u'];
      });
    }

    this.isLoggedIn();

    if (localStorage.getItem("returnURL")) {
      this.returnUrl = localStorage.getItem("returnURL");
      localStorage.removeItem("returnURL");
    } else {
      this.returnUrl = this.route.snapshot.queryParams['returnUrl'] || '/';
    }

    if (localStorage.getItem("returnURLParameters")) {
      this.returnParams = JSON.parse(localStorage.getItem("returnURLParameters"));
      localStorage.removeItem("returnURLParameters");
    }

  }

  isLoggedIn() {
    this.authService.logout();
    return false;
  }

  onLoginPressed() {
    this.isLoading = true;
    this.error='';
    this.loginService.authenticatePatient(this.username, this.password, this.token).subscribe((authData: AuthenticationResponseModel) => {

      this.isLoading = false;
      if (authData.isSuccess) {
        var res: any = authData;
        this.isLoading = false;

        if (this.storeToken(res)) {
          this.validated = true;
          localStorage.setItem("isPatientRole", "true");

          this.router.navigate(['/patientportal/home']);
          return;

        } else {
          this.error = 'token not returned';
          console.log('error: ', this.error);
        }
      }
      else {
        this.error = authData.message;
        console.log('login error: ', authData.message);
      }
    },
      (error) => {
        this.isLoading = false;
        console.log('error: ' + error.message);
        this.error = "Error processing Token Login.";
      });
  }

  RequestToken() {
    this.isLoading = true;
    this.error='';
    this.loginService.requestAuthToken(this.username).subscribe((authData: AuthenticationResponseModel) => {
      this.isLoading = false;
      if (authData.isSuccess) {
        //var res: any = authData;
        this.isLoading = false;
        this.token = authData.token;              
      }
      else {
        this.error = authData.message;
        console.log('login error: ', this.error);
      }
    },
      (error) => {
        console.log("requestAuthToken error", error);

        this.isLoading = false;
        console.log('error: ' + error.message);
        this.error = "Error processing Token request.";
      });
  }


  closeDialog() {
    if (this.tdodialog) {
      this.dialogRef.close(this.validated);
    }
  }

  onCancelPressed() {
    if (this.tdodialog) {
      this.router.navigate(['']);
      this.closeDialog();
    } else {
      this.username = '';
      this.password = '';
      this.token = '';
      this.validated = false;
      this.isLoading = false;
      this.error = null;
    }
  }

  storeToken(userInformation: any): boolean {
    const stored = this.authService.storePatientTokenResult(userInformation);
    return stored;
  }

  getstoredToken(): string {
    return localStorage.getItem("TDOPatientAuthToken");
  }

  loginShortcut() {
    if (!this.tdodialog) {
      this.onLoginPressed();
    }
  }

}
